import React, { useState } from "react";

import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Collapse,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  UncontrolledCollapse
} from "reactstrap";

import { Link, Redirect, useParams } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import classnames from "classnames";

// Pages Components
import CompanyList from "./components/company/list"
import SignupList from "./components/applicants/list"

const ConsoleDashboard = () => {

    let params = useParams()
  //meta title
  document.title = "Applicants | Equity Sales Finance, INC."
  
  const [customActiveTab, setcustomActiveTab] = useState("1");
  const [customIconActiveTab, setcustomIconActiveTab] = useState("1");
  const [col1, setcol1] = useState(true);
  const [col2, setcol2] = useState(false);
  const [col3, setcol3] = useState(false);

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Company & Applicants" breadcrumbItem="Dashboard" />
          <Row>            
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="h4">&nbsp;</CardTitle>
                  <p className="card-title-desc">&nbsp;</p>

                  <Nav tabs className="nav-tabs-custom nav-justified">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "1",
                        })}
                        onClick={() => {
                          toggleCustom("1");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-hospital-user"></i>
                        </span>
                        <span className="d-none d-sm-block">Active Company Users</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "2",
                        })}
                        onClick={() => {
                          toggleCustom("2");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-users"></i>
                        </span>
                        <span className="d-none d-sm-block">Submitted Applications</span>
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent
                    activeTab={customActiveTab}
                    className="p-3 text-muted"
                  >
                    <TabPane tabId="1">
                      <Row>
                        <Col sm="12">
                          <CompanyList 
                            params={params}
                          />
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="2">
                      <Row>
                        <Col sm="12">
                        <SignupList 
                            params={params}
                          />
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>     
      <ToastContainer />
    </React.Fragment>
  )
}

export default ConsoleDashboard
